import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AesEncdecService {
  private SECRET = '1234567890123456';

  constructor() { }

  encrypt(value: string) {
    const key = CryptoJS.enc.Utf8.parse(this.SECRET);
    const encrypted = CryptoJS.AES.encrypt(value, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }

  decrypt(cipherText: string) {
    const key = CryptoJS.enc.Utf8.parse(this.SECRET);
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
